import * as z from 'zod'
import type { TFunction } from 'i18next'

/** Schematy uwierzytelniania — przeniesione z
 *  `app/prototypes/src/schemas/auth.schema.ts`. Walidacja pozostaje produkcyjna
 *  (`z.string().trim().email()`, hasło niepuste po trim); fabryki przyjmują `t`,
 *  bo komunikaty idą przez i18n, a nie przez klucz w polu `message`. */

export const makeLoginSchema = (t: TFunction) =>
  z.object({
    email: z
      .string()
      .trim()
      .email({ message: t('loginPage.emailError') }),
    password: z.string().refine((value) => value.trim().length >= 1, { message: t('loginPage.passwordRequired') }),
  })

export type LoginFormValues = z.infer<ReturnType<typeof makeLoginSchema>>

export const makeResetPasswordSchema = (t: TFunction) =>
  z.object({
    email: z
      .string()
      .trim()
      .email({ message: t('resetPassword.emailError') }),
  })

export type ResetPasswordFormValues = z.infer<ReturnType<typeof makeResetPasswordSchema>>
